"use strict";
// The objects contain mappings as => item_value: item_label
// The lowercase(item_values) will be used for enumeration, internal record and storage to db
// The item_labels will be used for UI display purposes
Object.defineProperty(exports, "__esModule", { value: true });
exports.allTrackableMeasurementsLabels = exports.activitySpecificMeasurementLabels = exports.bodyMeasurementLabels = exports.accreditationLabels = exports.supplementLabels = exports.activityLabels = exports.dietLabels = exports.goalLabels = void 0;
const constants_1 = require("./constants");
exports.goalLabels = {
    [constants_1.Goal.WEIGHT_LOSS]: "Weight Loss",
    [constants_1.Goal.IMPROVE_FITNESS]: "Improve Fitness",
    [constants_1.Goal.WEIGHT_GAIN]: "Weight Gain",
    [constants_1.Goal.NO_GOAL]: "No Goal",
};
exports.dietLabels = {
    [constants_1.Diet.CARNIVORE]: "Carnivore",
    [constants_1.Diet.INTERMITTENT_FASTING]: "Intermittent Fasting",
    [constants_1.Diet.KETO]: "Keto",
    [constants_1.Diet.PALEO]: "Paleo",
    [constants_1.Diet.VEGAN]: "Vegan",
    [constants_1.Diet.VEGETARIAN]: "Vegetarian",
    [constants_1.Diet.VERTICAL_DIET]: "Vertical Diet",
};
exports.activityLabels = {
    [constants_1.Activity.BODYBUILDING]: "Bodybuilding",
    [constants_1.Activity.BOXING]: "Boxing",
    [constants_1.Activity.CALISTHENICS]: "Calisthenics",
    [constants_1.Activity.CROSSFIT]: "CrossFit",
    [constants_1.Activity.CYCLING]: "Cycling",
    [constants_1.Activity.HIIT]: "HIIT",
    [constants_1.Activity.PILATES]: "Pilates",
    [constants_1.Activity.POWERLIFTING]: "Powerlifting",
    [constants_1.Activity.ROWING]: "Rowing",
    [constants_1.Activity.PELOTON]: "Peloton",
    [constants_1.Activity.RUNNING]: "Running",
    [constants_1.Activity.SWIMMING]: "Swimming",
    [constants_1.Activity.WEIGHTLIFTING]: "Weightlifting",
    [constants_1.Activity.YOGA]: "Yoga",
    [constants_1.Activity.ZUMBA]: "Zumba",
};
exports.supplementLabels = {
    [constants_1.Supplement.HTP]: "5-HTP",
    [constants_1.Supplement.AAKG]: "AAKG (Arginine Alpha Ketoglutarate Powder)",
    [constants_1.Supplement.ALA]: "ALA (Alpha Lipoic Acid)",
    [constants_1.Supplement.BCAA]: "BCAA (Branched Chain Amino Acids)",
    [constants_1.Supplement.BETA_ALANINE]: "Beta Alanine",
    [constants_1.Supplement.CARNATINE]: "Carnatine",
    [constants_1.Supplement.CASEIN_PROTEIN]: "Casein Protein",
    [constants_1.Supplement.CITRULLINE]: "Citrulline",
    [constants_1.Supplement.CLA]: "CLA",
    [constants_1.Supplement.COD_LIVER_OIL]: "Cod Liver Oil",
    [constants_1.Supplement.COLLAGEN]: "Collagen",
    [constants_1.Supplement.COQ10]: "CoQ10",
    [constants_1.Supplement.CREATINE]: "Creatine",
    [constants_1.Supplement.D_ASPARTIC_ACID]: "D-Aspartic Acid",
    [constants_1.Supplement.EAA]: "EAA (Essential Amino Acids)",
    [constants_1.Supplement.FOLIC_ACID]: "Folic Acid",
    [constants_1.Supplement.GLUCOSAMINE]: "Glucosamine",
    [constants_1.Supplement.GLYCINE]: "Glycine",
    [constants_1.Supplement.GREEN_TEA_EXTRACT]: "Green Tea Extract",
    [constants_1.Supplement.HEMP_PROTEIN]: "Hemp Protein",
    [constants_1.Supplement.HMB]: "HMB (Beta-Hydroxy Beta-Methylbutyrate)",
    [constants_1.Supplement.IRON]: "Iron",
    [constants_1.Supplement.L_GLUTAMINE]: "L-Glutamine",
    [constants_1.Supplement.L_LYSINE]: "L-Lysine",
    [constants_1.Supplement.MACA]: "MACA",
    [constants_1.Supplement.MAGNESIUM]: "Magnesium",
    [constants_1.Supplement.MULTIVITAMIN]: "Multivitamin",
    [constants_1.Supplement.NAC]: "NAC (N-Acetyl Cysteine)",
    [constants_1.Supplement.OMEGA_3_FISH_OIL]: "Omega 3 Fish Oil",
    [constants_1.Supplement.PEA_PROTEIN]: "Pea Protein",
    [constants_1.Supplement.SOY_PROTEIN]: "Soy Protein",
    [constants_1.Supplement.TAURINE]: "Taurine",
    [constants_1.Supplement.TURMERIC]: "Turmeric",
    [constants_1.Supplement.VEGAN_PROTEIN]: "Vegan Protein",
    [constants_1.Supplement.VITAMIN_C]: "Vitamin C",
    [constants_1.Supplement.VITAMIN_D]: "Vitamin D",
    [constants_1.Supplement.WEIGHT_GAINER]: "Weight Gainer",
    [constants_1.Supplement.WHEY_PROTEIN]: "Whey Protein",
    [constants_1.Supplement.ZINC]: "Zinc",
    [constants_1.Supplement.ZMA]: "ZMA",
};
exports.accreditationLabels = {
    [constants_1.Accreditation.REPS]: "REPs",
    [constants_1.Accreditation.CIMSPA]: "CIMSPA",
    [constants_1.Accreditation.NASM]: "NASM",
    [constants_1.Accreditation.ACE]: "ACE",
    [constants_1.Accreditation.ISSA]: "ISSA",
    [constants_1.Accreditation.NFPT]: "NFPT",
    [constants_1.Accreditation.ACSM]: "ACSM",
};
exports.bodyMeasurementLabels = {
    [constants_1.BodyMeasurement.WEIGHT]: "Weight",
    [constants_1.BodyMeasurement.BODY_FAT]: "Body fat",
    [constants_1.BodyMeasurement.CHEST]: "Chest",
    [constants_1.BodyMeasurement.BUST]: "Bust",
    [constants_1.BodyMeasurement.UPPER_ARM]: "Upper arm",
    [constants_1.BodyMeasurement.WAIST]: "Waist",
    [constants_1.BodyMeasurement.THIGHS]: "Thighs",
    [constants_1.BodyMeasurement.CALVES]: "Calves",
    [constants_1.BodyMeasurement.HIPS]: "Hips",
};
exports.activitySpecificMeasurementLabels = {
    [constants_1.ActivitySpecificMeasurement.BENCH]: "Bench",
    [constants_1.ActivitySpecificMeasurement.SQUAT]: "Squat",
    [constants_1.ActivitySpecificMeasurement.DEADLIFT]: "Deadlift",
    [constants_1.ActivitySpecificMeasurement.PELOTON_RIDE]: "Peloton ride",
    [constants_1.ActivitySpecificMeasurement.ROW2K]: "2k row",
    [constants_1.ActivitySpecificMeasurement.ROW5K]: "5k row",
    [constants_1.ActivitySpecificMeasurement.RUN5KM]: "5km run",
    [constants_1.ActivitySpecificMeasurement.RUN10KM]: "10km run",
};
exports.allTrackableMeasurementsLabels = Object.assign(Object.assign({}, exports.bodyMeasurementLabels), exports.activitySpecificMeasurementLabels);
//# sourceMappingURL=labels.js.map